import { intersection } from 'lodash/array';
import { MOVE_OBJECT } from '%paysera_seat_selection/js/seatSelection/config/changeSet';
import compileRowTranslation from './compileRowTranslation';
import compileRowPolygon from './compileRowPolygon';
import compileRowLabel from './compileRowLabel';
import compileRowCacheKey from './compileRowCacheKey';
import compileSeat from '../compileSeat';

function compileRow(row, changeSet) {
    let compiledRow = row;

    if (intersection(changeSet.row, [MOVE_OBJECT]).length > 0) {
        compiledRow = compileRowTranslation(compiledRow);
        compiledRow.seats.toModelArray().forEach(seat => compileSeat(seat, changeSet));
        compiledRow = compileRowPolygon(compiledRow);
        compiledRow = compileRowCacheKey(compiledRow);

        return compiledRow;
    }

    compiledRow = compileRowTranslation(compiledRow);
    compiledRow.seats.toModelArray().forEach(seat => compileSeat(seat, changeSet));
    compiledRow = compileRowPolygon(compiledRow);
    compiledRow = compileRowLabel(compiledRow);
    compiledRow = compileRowCacheKey(compiledRow);

    return compiledRow;
}

export default compileRow;
